import React from 'react';

export default function NavButton({ page, currentPage, onClick, children }) {
    return (
        <button
            onClick={() => onClick(page)}
            className={`px-4 py-2 rounded-xl transition duration-300 font-medium ${currentPage === page
                ? 'bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-lg'
                : 'text-gray-600 hover:text-gray-800 hover:bg-indigo-50'
                }`}
        >
            {children}
        </button>
    );
}
